import { subDays } from 'date-fns'
import Domain from '@/lib/api/Domain'

const initialState = () => ({
  solicitation: false,
  domain: false,
  sale: null,
})

const state = initialState()

const getters = {
  hasDomainConfigured: (state) => {
    if (!state.domain || !state.domain.expire_at) return false
    let dateExpireAt = new Date(state.domain.expire_at).setHours(0, 0, 0, 0)
    dateExpireAt = subDays(dateExpireAt, 4)
    const dateToday = new Date().setHours(0, 0, 0, 0)
    return dateExpireAt >= dateToday
  },

  canCheckAvailability: (state, getters) => {
    if (!state.solicitation) return true
    if (state.solicitation.status != 'approved') return false

    const saleId = state.sale?.last_sale_id
    if (saleId && saleId !== state.solicitation?.id_venda) return true

    if (state.solicitation.status == 'approved') return false

    return !getters.hasDomainConfigured
  },
}

const actions = {
  async fetchDomainInitialState({ commit, rootGetters }) {
    const token = rootGetters['app/logonToken']
    const service = new Domain(token.token)
    const response = await service.getMySiteInfo()
    const mySiteInfo = response.data

    if (
      mySiteInfo?.solicitation &&
      mySiteInfo.solicitation != 'cancelled' &&
      mySiteInfo.solicitation != 'released'
    )
      commit('SET_SOLICITATION', mySiteInfo?.solicitation)

    if (mySiteInfo?.domain) commit('SET_DOMAIN', mySiteInfo.domain)
    if (mySiteInfo?.sale) commit('SET_SALE', mySiteInfo.sale)
  },

  setSolicitation(context, payload) {
    context.commit('SET_SOLICITATION', payload)
  },

  setDomain(context, payload) {
    context.commit('SET_DOMAIN', payload)
  },

  setSale(context, payload) {
    context.commit('SET_SALE', payload)
  },
}

const mutations = {
  SET_SOLICITATION(state, payload) {
    state.solicitation = payload
  },

  SET_DOMAIN(state, payload) {
    state.domain = payload
  },

  SET_SALE(state, payload) {
    state.sale = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
